import React, { useState, useRef, useEffect } from 'react';
import View from './UploadTerms.view';
import useGrouping from 'Common/Utils/Hooks/useGrouping';
import { uploadTermsConditions } from './service';
import { Redirect } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import useQualificationYear from 'Common/Utils/Hooks/useQualificationYear';
import groupings from 'Common/Constants/Groupings';
import { getTypes } from 'Common/Components/TeamTypeFilter/service';
import errorCb from 'Common/Utils/errorCb';

const UploadTermsContainer = () => {
	const initResult = { hasResult: false, result: null };

	const { qualYearLoaded, qualYear } = useQualificationYear();

	const grouping = useGrouping();
	const [year, updateYear] = useState(qualYear.toString());
	const inputRef = useRef(null);
	const [file, setFile] = useState(null);
	const [uploadResult, setUploadResult] = useState(initResult);
	const [closeRequested, setCloseRequested] = useState(false);
	const [yearSelectorHide, hideYearSelector] = useState(false);
	const [typeSelectorHide, hideTypeSelector] = useState(true);
	const [type, setType] = useState('');
	const [types, setTypes] = useState([]);
	
	const dispatch = useDispatch();

	const yearUpdated = yearIn => {
		if (grouping === groupings.Adhoc) {
			hideTypeSelector(false);
			apiGetTypes(yearIn);
		}
		updateYear(yearIn);
	};

	useEffect(() => {
		if (grouping === groupings.Marker || grouping === groupings.Invigilator) {
			yearUpdated(qualYear);
			hideYearSelector(true);
		}

		if (grouping === groupings.Adhoc) {
			hideTypeSelector(false);
			apiGetTypes(qualYear);
		}
	}, []);

	const title = `Upload terms & conditions for ${grouping}`;
	document.title = `Contract Management - ${title}`;    

	const selectClick = () => {
		if (file) {
			setFile(null);
		}
		if (uploadResult.hasResult) {
			setUploadResult(initResult);
		}
		inputRef.current.click();
	};

	const handleTypeChange = event => {
		setType(event.target.value);
	};

	const fileSelect = event => {
		setFile(event.target.files[0]);
	};

	const uploadClick = async () => {
		const result = await uploadTermsConditions(file, grouping, year, type);
		setUploadResult({ hasResult: true, result });
	};

	const onClose = () => {
		setCloseRequested(true);
	};

	if (closeRequested) {
		return <Redirect push to="/"></Redirect>;
	}

	const isUploadDisabled = () => {
		if (grouping === groupings.Adhoc) {
			return year === 0 || type === '' || types.length === 0;
		}
		if (grouping === groupings.AppointmentGroups || grouping === groupings.Verifier) {
			return year === 0;
		} else return false;
	};

	const apiGetTypes = async yearIn => {
		let didCancel = false;
		const apiTypes = await getTypes(yearIn, grouping, null, errorCb([], `Error fetching Types for ${grouping}`, dispatch));
		if (!didCancel) {
			setTypes(apiTypes);
		}
	};

	return (
		<View
			grouping={grouping}
			title={title}
			inputRef={inputRef}
			year={year.toString()}
			yearUpdated={yearUpdated}
			handleSelectClick={selectClick}
			handleFileSelect={fileSelect}
			filename={file?.name}
			handleUploadClick={uploadClick}
			uploadResult={uploadResult}
			onClose={onClose}
			yearSelectorHide={yearSelectorHide}
			typeSelectorHide={typeSelectorHide}
			type={type}
			types={types}
			handleTypeChange={handleTypeChange}
			isUploadDisabled={isUploadDisabled}
		/>
	);
};

export default UploadTermsContainer;
